module.exports = __webpack_public_path__ + "images/emoji/joy_cat.9b7095953c0b24d27c9d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/joy_cat.png
// module id = nJHd
// module chunks = 14